<template>
  <div class="wrapper login">
    <div class="body" >
      <div class="loginbox" v-show="showBody">
        <h1 class="login-logo">
          <img
            src="@/assets/images/TDSDC/logo_login_b.png"
            width="181"
            height="43"
            alt="TATSUZIN"
          />
        </h1>
        <p class="login-searvice-name">電帳法オプション</p>
        <!--
        ****  メッセージ表示領域 ****-->
        <p class="errMsg title-ico ico-warning alignleft" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p class="login-label alignleft ml-15px">プロダクトコード</p>
        <p class="login-item">
          <input
            type="text"
            class="frm-text"
            ref="prductCD"
            maxlength="41"
            v-model="prodCodetemp"
            :class="{ error: isErrorProdCode }"
            v-on:keydown.enter="onKeyEnter"
          />
        </p>
        <p class="errMsg alignleft ml-15px" v-show="errors_prodcode != ''">
          <ErrorMessageCase :errors="errors_prodcode"></ErrorMessageCase>
        </p>
        <p class="login-label alignleft ml-15px">ログインID</p>
        <p class="login-item">
          <input
            type="text"
            class="frm-text"
            maxlength="50"
            v-model="tatsuzinIdtemp"
            :class="{ error: isErrorAccId }"
            v-on:keydown.enter="onKeyEnter"
          />
        </p>
        <p class="errMsg alignleft ml-15px" v-show="errors_accid != ''">
          <ErrorMessageCase :errors="errors_accid"></ErrorMessageCase>
        </p>

        <p class="login-label alignleft ml-15px">パスワード</p>
        <PasswordInput
          ref="password"
          v-model="passwordtemp"
          :hasError="isErrorAccPass"
          v-on:keydown.enter="onKeyEnter"
        />
        <p class="errMsg alignleft ml-15px" v-show="errors_accpass != ''">
          <ErrorMessageCase :errors="errors_accpass"></ErrorMessageCase>
        </p>
        <p class="login-check">
          <label class="frm-checkbox">
            <input type="checkbox" v-model="LoginParam.loginInfoSaveFlag" />
            <span
              class="checkbox-item"
              tabindex="0"
              @keydown.space.stop.prevent="
                LoginParam.loginInfoSaveFlag = !LoginParam.loginInfoSaveFlag
              "
            ></span>
            <span class="checkbox-text"
              >プロダクトコード、ログインIDを保持する</span
            >
          </label>
        </p>
        <p class="login-btn">
          <button
            class="frm-btn strong large"
            type="button"
            @click="login"
            :disabled="isLoginDesabled"
            v-on:keydown.enter="onKeyEnter"
          >
            ログイン
          </button>
        </p>
      </div>
    </div>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：利用規約画面(STDSCM04C04)  ログイン時、利用規約未同意で表示                                       _/
         _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <TearmsOfService
      :requiredTermsOfUseUrl="requiredTermsOfUseUrl"
      @confirm="confirm"
    ></TearmsOfService>
    <STDSCM01C02LoginConfrimModal
      :isConfirmShow="isConfirmShow"
      :message="message"
      @agree="agree"
    ></STDSCM01C02LoginConfrimModal>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
          _/                                                                                                                   _/
          _/      子画面定義：パスワード変更画面(STDSCM01C03)　　税理士事務所用                                                    _/
          _/                                                                                                                   _/
        _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <STDSCM01C03PasswordChangeModal
      :isProcessShow="isProcessShow"
      :oldPassWord="passwordtemp"
      :tatsuzinId="tatsuzinIdtemp"
      TdsCssFlg="1"
      @send="send"
      @cancel="cancel"
    ></STDSCM01C03PasswordChangeModal>
  </div>
</template>
<script>
import _ from "lodash";
import { mapMutations } from "vuex";
import TearmsOfService from "@/components/STDSCM04C04TearmsOfServiceModal.vue";
import STDSCM01C02LoginConfrimModal from "@/components/STDSCM01C02LoginConfrimModal.vue";
import STDSCM01C03PasswordChangeModal from "@/components/STDSCM01C03PasswordChangeModal.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import PasswordInput from "@/components/PasswordInput.vue";
import Validation from "@/util/validation.js";
import Common from "@/util/common.js";
import { API_STDSCM01C01 } from "@/api/Modules/CM01/STDSCM01C01.js";

export default {
  name: "STDSCM01C01",
  components: {
    TearmsOfService,
    STDSCM01C02LoginConfrimModal,
    STDSCM01C03PasswordChangeModal,
    ErrorMessage,
    ErrorMessageCase,
    PasswordInput,
  },
  data() {
    return {
      showBody:false,
      LoginParam: {
        productCode: "",
        tatsuzinId: "",
        password: "",
        loginInfoSaveFlag: false,
        cubeAuthenticationInfo: "",
        agreedTermsOfUseId: null,
        loginSystem: "",
        assignedDeviceCode: this.$cookies.get("assignedDeviceCode"),
        isMobile: Common.isMobile(),
      },
      isConfirmShow: false,
      message: "",
      prodCodetemp: "",
      tatsuzinIdtemp: "",
      passwordtemp: "",
      errors: [], // エラー情報
      errors_prodcode: [], // エラー情報_プロダクトコード
      errors_accid: [], // エラー情報_ログインID
      errors_accpass: [], // エラー情報_パスワード
      isErrorProdCode: false, // プロダクトコード_エラー表示
      isErrorAccId: false, // 事業者ID_エラー表示
      isErrorAccPass: false, // パスワード_エラー表示
      isLoginDesabled: false, // ログインボタン_活性状態
      msg: Common.getMessage("MTCL2070", []), //capslockメッセージ
      requiredTermsOfUseUrl: "",
      requiredTermsOfUseVersion: null,
      requiredTermsOfUseId: null,
      loginStatus: 1, // 1:普通ログイン　2:CUBEからログイン
      retstatus: true,
      keyenterflg: false,
      isProcessShow: false,
      changeNewPassword: "",
      
    };
  },
  created() {
    if(this.$route.query.cainfo ){
      this.showBody = false
    } else {
      this.showBody = true
    }
    this.$store.commit("businessModule/processDialogue",false)
    // クッキーの取り出し
    const productCode = this.$cookies.get("productCode");
    const tatsuzinId = this.$cookies.get("tatsuzinId");
    (this.prodCodetemp = _.isNil(productCode)
      ? this.prodCodetemp
      : productCode),
      (this.tatsuzinIdtemp = _.isNil(tatsuzinId)
        ? this.tatsuzinIdtemp
        : tatsuzinId);
    if (!_.isNil(productCode) || !_.isNil(tatsuzinId)) {
      this.LoginParam.loginInfoSaveFlag = true;
    }
  },
  watch: {
    //prodCodetempの変化を検知してプロダクトコードを整形する
    prodCodetemp(newValue, oldValue) {
      this.LoginParam.productCode = newValue;

      //プロダクトコード入力有無チェック
      if (newValue.length < oldValue.length) {
        return;
      }

      let temValue = newValue.trim().replace(/-/g, "");
      if (temValue.length <= 8) {
        this.prodCodetemp = temValue;
      } else if (temValue.length > 8 && temValue.length <= 12) {
        this.prodCodetemp =
          temValue.substring(0, 8) +
          "-" +
          temValue.substring(8, temValue.length);
      } else if (temValue.length > 12 && temValue.length <= 16) {
        this.prodCodetemp =
          temValue.substring(0, 8) +
          "-" +
          temValue.substring(8, 12) +
          "-" +
          temValue.substring(12, temValue.length);
      } else if (temValue.length > 16 && temValue.length <= 20) {
        this.prodCodetemp =
          temValue.substring(0, 8) +
          "-" +
          temValue.substring(8, 12) +
          "-" +
          temValue.substring(12, 16) +
          "-" +
          temValue.substring(16, temValue.length);
      } else if (temValue.length > 20 && temValue.length <= 32) {
        this.prodCodetemp =
          temValue.substring(0, 8) +
          "-" +
          temValue.substring(8, 12) +
          "-" +
          temValue.substring(12, 16) +
          "-" +
          temValue.substring(16, 20) +
          "-" +
          temValue.substring(20, temValue.length);
      } else {
        this.prodCodetemp =
          temValue.substring(0, 8) +
          "-" +
          temValue.substring(8, 12) +
          "-" +
          temValue.substring(12, 16) +
          "-" +
          temValue.substring(16, 20) +
          "-" +
          temValue.substring(20, 32) +
          "-" +
          temValue.substring(32, temValue.length);
      }
    },
    //ID入力有無チェック
    tatsuzinIdtemp(newVal) {
      this.LoginParam.tatsuzinId = newVal;
    },
    // パスワード入力有無チェック
    passwordtemp(newVal) {
      this.LoginParam.password = newVal;
    },
  },
  methods: {
    ...mapMutations("businessModule", ["termsServiceDialogue"]),
    ...mapMutations("businessOperatorModule", ["updateBusinessOperatorFlag"]),
    //体験版残日数ダイアログ　OK
    agree() {
      this.isConfirmShow = false;
      //ページ移動
      this.$redirect({ name: "STFMFM01C01" });
    },

    // ログイン処理：利用規約同意
    confirm() {
      //利用規約未同意画面非表示
      this.termsServiceDialogue(false);
      this.LoginParam.agreedTermsOfUseVersion = this.requiredTermsOfUseVersion;
      this.LoginParam.agreedTermsOfUseId = this.requiredTermsOfUseId;
      if (this.changeNewPassword != "") {
        this.LoginParam.password = this.changeNewPassword;
      }
      if (this.loginStatus === 1) {
        this.login();
      } else {
        this.loginFromCube();
      }
    },

    // ログイン処理
    login() {
      if (!this.handlePushLoginButton()) {
        this.LoginParam.loginInfoSaveFlag = false;
        return;
      }

      const { productCode, tatsuzinId, loginInfoSaveFlag } = this.LoginParam;
      // 入力情報保持がチェックONの場合
      if (loginInfoSaveFlag) {
        // クッキーの設定を有効にする
        this.$cookies.set("productCode", productCode, -1);
        this.$cookies.set("tatsuzinId", tatsuzinId, -1);
      } else {
        // クッキーの削除
        this.$cookies.remove("productCode");
        this.$cookies.remove("tatsuzinId");
      }

      //ログインボタン　非活性化
      this.isLoginDesabled = true;

      //ログインメソッドを呼ぶ
      API_STDSCM01C01(this.LoginParam).then((response) => {
        this.$cookies.set("isBopLogin", "false", "0");
        if (response.result == "0000") {
          // 正常時
          this.$cookies.set("SessionID", response.sessionID, "0");
          this.$cookies.set("preOcclusionFlag", true, "0");
          this.$cookies.set("isloginHendle", false, "0");
          this.$cookies.set(
            "assignedDeviceCode",
            response.assignedDeviceCode,
            "0"
          );
          this.updateBusinessOperatorFlag(false);
          if (response.availableDays !== 0) {
            this.message = Common.getMessage("MTCL2071", [
              response.availableDays,
            ]);
            this.isConfirmShow = true;
          } else {
            //ページ移動
            this.$redirect({ name: "STFMFM01C01" });
          }
        } else if (response.result == "0900" || response.result == "0901") {
          this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
          this.requiredTermsOfUseId = response.requiredTermsOfUseId;
          this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;
          //ログインステータス
          this.loginStatus = 1;
          //利用規約未同意画面表示
          this.termsServiceDialogue(true);
        } else if (response.result == "1700") {
          //パスワード再利用の場合　※返却コード値はリファレンス待ち
          this.isProcessShow = true;
        } else if (response.result == "0800") {
          window.location.href = response.url;
        } else if (response.result == "0100") {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [response.errorName[0]])
            )
          );
        } else {
          // エラー時
          // フォーカス制御
          this.passwordtemp = "";
          switch (response.result) {
            case "0700":
              this.$refs.prductCD.focus();
              break;
            default:
              this.$refs.password.focus();
              break;
          }
          // 入力クリア
          this.LoginParam.password = "";
          this.LoginParam.loginInfoSaveFlag = false;
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }

        //ログインボタン　活性化
        this.isLoginDesabled = false;
        this.keyenterflg = false;
      });
    },

    //CUBEから ログイン処理
    loginFromCube() {
      //URLパラメータがある場合、Cubeログイン
      if (this.$route.query.cainfo != null) {
        let param = {
          cubeAuthenticationInfo: this.$route.query.cainfo,
          agreedTermsOfUseId: this.requiredTermsOfUseId,
          agreedTermsOfUseVersion: this.requiredTermsOfUseVersion,
          assignedDeviceCode: this.$cookies.get("assignedDeviceCode"),
        };
        API_STDSCM01C01(param).then((response) => {
          this.$cookies.set("isBopLogin", "false", "0");
          if (response.result == "0000") {
            // 正常時
            this.$cookies.set("SessionID", response.sessionID, "0");
            this.$cookies.set(
              "assignedDeviceCode",
              response.assignedDeviceCode,
              "0"
            );
            this.updateBusinessOperatorFlag(false);
            if (response.availableDays !== 0) {
              this.message = Common.getMessage("MTCL2071", [
                response.availableDays,
              ]);
              this.isConfirmShow = true;
            } else {
              //ページ移動
              this.$redirect({ name: "STFMFM01C01" });
            }
          } else if (response.result == "0800") {
            this.$redirect({ name: response.url });
          } else if (response.result == "0900" || response.result == "0901") {
            this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
            this.requiredTermsOfUseId = response.requiredTermsOfUseId;
            this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;

            //ログインステータス
            this.loginStatus = 2;
            //利用規約未同意画面表示
            this.termsServiceDialogue(true);
          } else {
            // エラー時
            // フォーカス制御
            this.passwordtemp = "";
            switch (response.result) {
              case "0700":
                this.$refs.prductCD.focus();
                break;
              default:
                this.$refs.password.focus();
                break;
            }
            // 入力クリア
            this.LoginParam.password = "";
            this.LoginParam.loginInfoSaveFlag = false;
            // エラー表示;
            this.errors.push(
              Common.createError(
                response.errorCD,
                Common.getMessage(response.errorCD, [])
              )
            );
          }
        });
      }
    },

    // プロダクトコード入力値チェック
    focusoutProdCode(input) {
      this.isErrorProdCode = false;
      // 必須チェック
      if (!input) {
        this.isErrorProdCode = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_prodcode || this.errors_prodcode.length == 0) {
          this.errors_prodcode.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["プロダクトコード"])
            )
          );
        }
        return false;
        // 半角チェック
      } else if (!Validation.isHalf(input)) {
        this.isErrorProdCode = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_prodcode || this.errors_prodcode.length == 0) {
          this.errors_prodcode.push(
            Common.createError(
              "MTCL1003",
              Common.getMessage("MTCL1003", ["プロダクトコード"])
            )
          );
        }
        return false;
      }
      return true;
    },

    // ログインID入力値チェック
    focusoutAccID(input) {
      this.isErrorAccId = false;
      // 必須チェック
      if (!input) {
        this.isErrorAccId = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accid || this.errors_accid.length == 0) {
          this.errors_accid.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["ログインID"])
            )
          );
        }
        return false;
        // 半角チェック
      } else if (!Validation.isHalf(input)) {
        this.isErrorAccId = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accid || this.errors_accid.length == 0) {
          this.errors_accid.push(
            Common.createError(
              "MTCL1003",
              Common.getMessage("MTCL1003", ["ログインID"])
            )
          );
        }
        return false;
      }
      return true;
    },

    // パスワード入力値チェック
    focusoutPass(input) {
      this.isErrorAccPass = false;
      // 必須チェック
      if (!input) {
        this.isErrorAccPass = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accpass || this.errors_accpass.length == 0) {
          this.errors_accpass.push(
            Common.createError(
              "MTCL1001",
              Common.getMessage("MTCL1001", ["パスワード"])
            )
          );
        }
        return false;
        // 半角チェック
      } else if (!Validation.isHalf(input)) {
        this.isErrorAccPass = true;
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
          );
        }
        if (!this.errors_accpass || this.errors_accpass.length == 0) {
          this.errors_accpass.push(
            Common.createError(
              "MTCL1003",
              Common.getMessage("MTCL1003", ["パスワード"])
            )
          );
        }
        return false;
      }
      return true;
    },
    // モバイルログインチェック
    loginMobile(input) {
      if(input){
        if (!this.errors || this.errors.length == 0) {
          this.errors.push(
            Common.createError("MTCL1172",Common.getMessage("MTCL1172", []))
          );
        }
        return false;
      }
      return true;
    },

    // ログインボタン押下時入力チェック
    handlePushLoginButton() {
      this.errors = [];
      this.errors_prodcode = [];
      this.errors_accid = [];
      this.errors_accpass = [];
      if (!this.loginMobile(this.LoginParam.isMobile)) {
        this.retstatus = false;
      }
      else{
        if (!this.focusoutProdCode(this.LoginParam.productCode))
          this.retstatus = false;
        if (!this.focusoutAccID(this.LoginParam.tatsuzinId))
          this.retstatus = false;
        if (!this.focusoutPass(this.LoginParam.password)) this.retstatus = false;
      }
      if (!this.retstatus) {
        this.keyenterflg = false;
        this.retstatus = true;
        return false;
      }
      return true;
    },

    // Enterキーでログイン処理を呼び出す
    keyenterflg_operation() {
      this.keyenterflg = true;
    },
    onKeyEnter: function () {
      //Enterキー連打防止
      if (this.keyenterflg) return;
      this.keyenterflg_operation();
      this.login();
    },

    //パスワード変更画面_キャンセルボタン押下時
    cancel() {
      this.isProcessShow = false;
    },
    //パスワード変更画面_パスワード変更ボタン押下時
    send(psw) {
      //ユーザー認証クラス.パスワード変更サインイン(事業者用)、ログインを行う。
      const param = {
        tatsuzinId: this.LoginParam.tatsuzinId,
        password: this.LoginParam.password,
        newPassword: psw,
        assignedDeviceCode: this.$cookies.get("assignedDeviceCode"),
        productCode: this.LoginParam.productCode,
      };

      // パスワード変更ボタン 非活性化
      this.passwordChangeDisabled = true;

      API_STDSCM01C01(param).then((response) => {
        this.$cookies.set("isBopLogin", "false", "0");
        if (response.result == "0000") {
          this.$cookies.set("SessionID", response.sessionID, "0");
          this.$cookies.set("preOcclusionFlag", true, "0");
          this.$cookies.set(
            "assignedDeviceCode",
            response.assignedDeviceCode,
            "0"
          );
          this.updateBusinessOperatorFlag(false);
          if (response.availableDays !== 0) {
            this.message = Common.getMessage("MTCL2071", [
              response.availableDays,
            ]);
            this.isConfirmShow = true;
          } else {
            //ページ移動
            this.$redirect({ name: "STFMFM01C01" });
          }
        } else if (response.result == "0900" || response.result == "0901") {
          this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
          this.requiredTermsOfUseId = response.requiredTermsOfUseId;
          this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;
          this.changeNewPassword = psw;
          //ログインステータス
          this.loginStatus = 1;
          //利用規約未同意画面表示
          this.termsServiceDialogue(true);
        } else if (response.result == "0800") {
          //体験版利用期限切れ 指定ページに遷移する。
          window.location.href = response.url;
        } else if (response.result == "0100") {
          // エラー時フォーカス制御
          this.passwordtemp = "";
          this.$refs.password.focus();
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [response.errorName[0]])
            )
          );
        } else if (response.result == "1900") {
          // エラー時フォーカス制御
          this.passwordtemp = "";
          this.$refs.password.focus();
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        } else {
          this.$router.push({
            name: "STDSCM04C06",
            state: {
              message: Common.getMessage(response.errorCD, []),
            },
          });
        }

        // パスワード変更ボタン 活性化
        this.passwordChangeDisabled = false;
      });

      this.isProcessShow = false;
    },
  },
  //画面表示前処理
  beforeCreate() {
    // リロードを行うか
    if (history.state.reload != null) {
      history.state.reload = null;
      location.reload();
    }

    //URLパラメータがある場合、Cubeログイン
    if (this.$route.query.cainfo != null) {
      // beforeCreateだとthis.LoginParamが定義される前？のため
      let param = {
        cubeAuthenticationInfo: this.$route.query.cainfo,
        assignedDeviceCode: this.$cookies.get("assignedDeviceCode"),
      };
      API_STDSCM01C01(param).then((response) => {
        this.$cookies.set("isBopLogin", "false", "0");
        if (response.result == "0000") {
          // 正常時
          this.$cookies.set("SessionID", response.sessionID, "0");
          this.$cookies.set(
            "assignedDeviceCode",
            response.assignedDeviceCode,
            "0"
          );
          this.updateBusinessOperatorFlag(false);
          if (response.availableDays !== 0) {
            this.message = Common.getMessage("MTCL2071", [
              response.availableDays,
            ]);
            this.isConfirmShow = true;
          } else {
            //ページ移動
            this.$redirect({ name: "STFMFM01C01" });
          }
        } else if (response.result == "0800") {
          this.$redirect({ name: response.url });
        } else if (response.result == "0900" || response.result == "0901") {
          this.requiredTermsOfUseVersion = response.requiredTermsOfUseVersion;
          this.requiredTermsOfUseId = response.requiredTermsOfUseId;
          this.requiredTermsOfUseUrl = response.requiredTermsOfUseUrl;

          //ログインステータス
          this.loginStatus = 2;
          //利用規約未同意画面表示
          this.termsServiceDialogue(true);
        } else {
          this.showBody = true
          // エラー時
          // フォーカス制御
          this.passwordtemp = "";
          switch (response.result) {
            case "0700":
              this.$refs.prductCD.focus();
              break;
            default:
              this.$refs.password.focus();
              break;
          }
          // 入力クリア
          this.LoginParam.password = "";
          this.LoginParam.loginInfoSaveFlag = false;
          // エラー表示;
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      });
    }
  },

  mounted() {
    //初期フォーカス
    this.$refs.prductCD.focus();
  },
};
</script>

<style scoped>
.loginbox {
  height: auto;
}
</style>
